import { createContext, useReducer, useContext, useEffect } from "react";
import Swal from "sweetalert2";
import axios from "../../api/axios";
import { useLocation, useNavigate } from "react-router-dom";
import {
  LOGGED_IN,
  NOT_LOGGED_IN,
  STATUS_NOT_LOADED,
} from "../../api/constant";
import {
  alertSuccess,
  showErrors,
  showTypeErrorFetch,
} from "../../utilities/alerts.utilities";
import {
  authReducer,
  initialState,
  types,
} from "../../reducers/security/authReducer";

const AuthContext = createContext({});

const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(authReducer, initialState);
  const location = useLocation();

  let navigate = useNavigate();
  useEffect(() => {
    const from = location.state?.from?.pathname || location.pathname;
    if (state.userStatus === STATUS_NOT_LOADED) {
      axios()
        .get("security/getuser")
        .then(({ data }) => {
          if (!data) {
            dispatch({ type: types.NOT_LOGGED_IN_FETCH });
          } else {
            dispatch({ type: types.LOGGED_IN_FETCH, payload: data });
          }
        })
        .catch((err) => {});
    }
    if (state.userStatus === LOGGED_IN) {
      navigate(from === "/login" ? "/inventory/articles" : from);
    }
    if (state.userStatus === NOT_LOGGED_IN && from === "/") {
      navigate("/login");
    }
  }, [state]);

  const fetchLogin = (e) => {
    e.preventDefault();
    dispatch({ type: types.LOADING_LOGGIN_FETCH });
    axios()
      .post("security/login", state.loginForm)
      .then(({ data }) => {
        if (localStorage) {
          localStorage.setItem("token", `Bearer ${data.token}`);
          dispatch({ type: types.NOT_LOADED });
        }
      })
      .catch((e) => {
        dispatch({ type: types.NOT_LOGGED_IN_FETCH });
        showErrors(e.response.data);
      });
  };
  const sendEmailPassword = (email) => {
    axios()
      .post(`security/password/email`, { email: email })
      .then(({ data }) => {
        Swal.fire({
          title: "Se ha enviado un link al correo",
          text: "Puede llegar a la lista de spam o notificaciones",
          icon: "success",
          confirmButtonColor: "#df8c37",
          cancelButtonColor: "#171e27",
          confirmButtonText: "Entendido",
        }).then((result) => {});
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };
  const changeToken = (token) => {
    dispatch({ type: types.RESET_TOKEN,payload: token });
  };
  const resetPassword = ({ email, password, password_confirmation }) => {
    var formData = new FormData();
    formData.append("email", email);
    formData.append("password", password);
    formData.append("token", state.tokenReset);

    formData.append("password_confirmation", password_confirmation);

    axios()
      .post("security/password/reset/" + state.tokenReset, formData)
      .then(({ data }) => {
        alertSuccess("Contraseña restablecida");
        navigate("/login");
        logout();
      })
      .catch((e) => {
        showTypeErrorFetch(e);
      });
  };

  const logout = () => {
    localStorage.removeItem("token");
    dispatch({ type: types.AUTH_LOGOUT });
  };

  return (
    <AuthContext.Provider
      value={[
        state,
        dispatch,
        { fetchLogin, logout, sendEmailPassword, changeToken, resetPassword },
      ]}
    >
      {children}
    </AuthContext.Provider>
  );
};
const useAuth = () => useContext(AuthContext)[0];
const useDispatch = () => useContext(AuthContext)[1];
const useActions = () => useContext(AuthContext)[2];

export { AuthContext, useAuth, useDispatch, useActions };
export default AuthProvider;
